export function read() {
  return JSON.parse(localStorage.getItem('searchHistory') || '[]');
}

export function write(searchHistory) {
  return localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
}

export function append(searchedItem) {
  let currentHistory = read();
  if (currentHistory) {
    if (!currentHistory.some((e) => e.title == searchedItem.title)) {
      currentHistory.unshift(searchedItem);
      write(currentHistory.slice(0, 5));
    }
  } else {
    write([searchedItem]);
  }
}

export function clear() {
  localStorage.removeItem('searchHistory');
}

export default {
  read,
  write,
  append,
  clear,
};
